import React from 'react';
import { DeckSlideWrapper } from '../DeckSlideWrapper';
import { CheckCircle2 } from 'lucide-react';

export const Slide09Roadmap: React.FC = () => {
  const milestones = [
    {
      quarter: 'Q3 2026',
      status: 'Current Execution',
      statusColor: 'text-gold-600 dark:text-gold-400 bg-gold-500/10 border-gold-500/30',
      title: 'Private Beta, Edge Billing & WAP Core',
      items: [
        'Launch Private Beta cohort with 15 design partners',
        'Cloudflare Edge multi-tenant gateway deployment',
        'LemonSqueezy SaaS subscription & usage metering',
        'Workouse Action Protocol (WAP) Paraşüt & CRM plugins',
      ],
    },
    {
      quarter: 'Q4 2026',
      status: 'Planned',
      statusColor: 'text-blue-600 dark:text-blue-400 bg-blue-500/10 border-blue-500/30',
      title: 'V8 Sandboxes & Reusable Workflow Apps',
      items: [
        'Isolated V8 dynamic dispatch & Deno runners',
        'Two-Phase HITL dry-run visual diff card approval',
        'Saved Reusable Workflow Apps with slash commands',
        'Visual DLP Regex & Custom NER Rule Studio',
      ],
    },
    {
      quarter: 'Q1 2027',
      status: 'Planned',
      statusColor: 'text-purple-600 dark:text-purple-400 bg-purple-500/10 border-purple-500/30',
      title: 'HashiCorp Vault & SOC 2 Certification',
      items: [
        'HashiCorp Vault enterprise on-prem connector',
        'SOC 2 Type I & ISO 27001 certification audit',
        'Air-gapped on-prem container distribution for banks',
        'Enterprise Okta / Azure AD SAML marketplace listings',
      ],
    },
    {
      quarter: 'Q2–Q4 2027',
      status: 'Vision',
      statusColor: 'text-emerald-600 dark:text-emerald-400 bg-emerald-500/10 border-emerald-500/30',
      title: 'Autonomous Agentic Gateway & Series A',
      items: [
        'Autonomous agent tool-call DLP & spend arbitration',
        'Cross-region high-concurrency Edge Mesh',
        'Reach $1.2M ARR milestone with 50+ enterprise orgs',
        'Prepare Series A institutional financing round',
      ],
    },
  ];

  return (
    <DeckSlideWrapper
      slideNumber={9}
      totalSlides={12}
      category="Execution Roadmap"
      title="18-Month Product &amp; Growth Milestones"
      subtitle="Disciplined technical milestones designed to achieve $1.2M ARR and enterprise compliance certification."
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-3.5 items-stretch">
        {milestones.map((m, idx) => (
          <div
            key={idx}
            className="p-3.5 sm:p-4 rounded-2xl bg-white/90 dark:bg-navy-850/80 border border-slate-200 dark:border-navy-700 shadow-sm flex flex-col justify-between"
          >
            <div>
              <div className="flex items-center justify-between mb-1.5 sm:mb-2">
                <span className="font-mono text-xs sm:text-sm font-extrabold text-slate-900 dark:text-white">
                  {m.quarter}
                </span>
                <span className={`px-2 py-0.5 rounded text-[10px] font-mono font-bold border ${m.statusColor}`}>
                  {m.status}
                </span>
              </div>
              <h4 className="font-bold text-xs sm:text-sm text-slate-900 dark:text-white mb-2 sm:mb-2.5">
                {m.title}
              </h4>
              <ul className="space-y-1.5 text-[11px] text-slate-600 dark:text-slate-300">
                {m.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-1.5 leading-tight">
                    <CheckCircle2 className="w-3.5 h-3.5 text-gold-500 shrink-0 mt-0.5" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="mt-3 pt-2 border-t border-slate-200 dark:border-navy-700/60 font-mono text-[10px] text-slate-400">
              Phase 0{idx + 1}
            </div>
          </div>
        ))}
      </div>
    </DeckSlideWrapper>
  );
};
